import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sheet: null
};

const orderImportSlice = createSlice({
  name: 'orderImport',
  initialState,
  reducers: {
    setSelectedSpreadsheet: (state, { payload: { sheet } }) => {
      state.sheet = sheet;
    }
  }
});

export const { setSelectedSpreadsheet } = orderImportSlice.actions;

export default orderImportSlice.reducer;
